import { LINECHART_DATE_RANGES_TYPE } from "./types";

const DEFAULT_DATE_RANGE = "oneYear" as LINECHART_DATE_RANGES_TYPE;

const WIDGET_ID = "result-sentiment-trends";

export { DEFAULT_DATE_RANGE, WIDGET_ID };
